export enum FrontLinkTypeEnum {
  page = 1,
  category = 2,
  product = 3,
  custom = 5,
  collection = 8,
  pack = 9,
  document = 10,
  landing = 11
}
